import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';
import { FrontendMode, MobileAppHelperBaseService } from '@fi-shared/fi-shared-services/mobile-app-helper-base.service';
import { FiClientType } from '@fi-shared/types/fi-client-type';

@Injectable()
export class FiClientTypeInterceptor implements HttpInterceptor {
    constructor(
        private fiBackend: FiBackendService,
        private mobileAppService: MobileAppHelperBaseService,
    ) {}

    intercept(request: HttpRequest<any>, next: HttpHandler) {
        if (!this.fiBackend.isExternalApiUrl(request.url)) {
            const clientType =
                this.mobileAppService.frontEndMode === FrontendMode.MobileApp
                    ? FiClientType.CordovaMobileApp
                    : FiClientType.Web;
            request = request.clone({
                setHeaders: {
                    'Fi-Client-Type': clientType.toString(),
                },
            });
        }
        return next.handle(request);
    }
}
